export default "__VITE_ASSET__213591b1__"